import React, { PropTypes } from 'react';
import cn from 'classnames';
import { Angle } from '@bibliocommons/base-icons';

import './SidebarCompactTitle.scss';

export default function SidebarCompactTitle({ title, count, selected }) {
  return (
    <div className={cn('cp-sidebar-compact-title', { selected })}>
      {title}
      <div className="count-wrapper">
        <div className="count">{count}</div>
        <div className="icon-wrapper"><Angle.Right /></div>
      </div>
    </div>
  );
}

SidebarCompactTitle.propTypes = {
  title: PropTypes.node,
  count: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.number,
    PropTypes.string
  ]),
  selected: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SidebarCompactTitle/SidebarCompactTitle.jsx